module.exports = __webpack_public_path__ + "files/002177ae30f398c5ee012f2e085ac2b5.png";